import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../store';
import { logoutSuccess } from '../store/authSlice';

const NavBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);

  const handleLogout = () => {
    localStorage.clear();
    dispatch(logoutSuccess());
    navigate('/login');
  };

  const isActive = (basePath: string) => {
    if (basePath === '/projects') {
      return (
        location.pathname === '/projects' ||
        location.pathname.startsWith('/project/') ||
        location.pathname.startsWith('/map/') ||
        location.pathname.startsWith('/course-elements/')
      );
    }
    return location.pathname === basePath;
  };

  const linkClass = (basePath: string) =>
    `text-sm font-medium pb-0.5 transition-colors ${
      isActive(basePath)
        ? 'text-blue-600 border-b-2 border-blue-600'
        : 'text-gray-600 hover:text-gray-900'
    }`;

  return (
    <nav className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">

          {/* Logo — clicking takes all roles to their home */}
          <button onClick={() => navigate('/')} className="flex items-center flex-shrink-0">
            <img
              src="/Logo_Small.png"
              alt="Eleven Eagles"
              className="h-10 w-auto rounded-lg"
            />
          </button>

          {/* Nav links + actions */}
          <div className="flex items-center space-x-6">
            {user?.role === 'admin' && (
              <>
                <button onClick={() => navigate('/projects')} className={linkClass('/projects')}>
                  Projects
                </button>
                <button onClick={() => navigate('/users')} className={linkClass('/users')}>
                  User Management
                </button>
              </>
            )}

            {user?.role === 'designer' && (
              <button onClick={() => navigate('/projects')} className={linkClass('/projects')}>
                Projects
              </button>
            )}

            <div className="flex items-center space-x-4 pl-4 border-l border-gray-200">
              <button onClick={() => navigate('/profile')} className={linkClass('/profile')}>
                {user?.name || 'Profile'}
              </button>
              <button
                onClick={handleLogout}
                className="bg-red-600 text-white px-3 py-1.5 rounded-md text-sm font-medium hover:bg-red-700 transition-colors"
              >
                Logout
              </button>
            </div>
          </div>

        </div>
      </div>
    </nav>
  );
};

export default NavBar;
